import React, { useEffect, useId, useState } from 'react'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getLobbyOrder, updateLobbyOrder } from '../../services/lobbyOrder'
import {lobbyTab, modalTag} from './types'
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle,
} from "react-beautiful-dnd";
import FloatingButton from '../../components/UI/FloatingButton';
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth';
import { serverUrl } from '../../services/api';
import {CSVLink} from "react-csv";
import {DeleteOutlined, PlusOutlined, TagsOutlined} from "@ant-design/icons";
import {Button, Space} from "antd";
import ModalTagsSelector from "./ModalPTTagsSelector";
import {addTag, getLobbyTabs, saveLobbyTabs} from "../../services/pttags";
import Input from "../../components/UI/Input";

const reorder = (
  list: lobbyTab[],
  startIndex: number,
  endIndex: number
): lobbyTab[] => {
  console.log("reorder: " + JSON.stringify(list) + " Start: " + startIndex.toString() + " end: " + endIndex.toString())
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 20;

const getItemStyle = (
  isDragging: boolean,
  draggableStyle: DraggingStyle | NotDraggingStyle | undefined
): React.CSSProperties => ({
  userSelect: "none",
  padding: '10px 20px',
  margin: `0 0 8px 0`,
  border: '1px solid rgba(0, 0, 0)',
  color: isDragging ? 'white' : '#000',
  backgroundColor: isDragging ? '#000' : 'transparent',
  fontWeight: 'bold',
  ...draggableStyle
});

const getListStyle = (isDraggingOver: boolean): React.CSSProperties => ({
  backgroundColor: isDraggingOver ? 'rgba(0, 0, 0, 0.0588235294)': '#FFF',
  padding: '20px 30px',
  transition: 'all 0.3s',
  width: 1000,
});


function index(props: { accessLevel: string }) {
  const {canEdit} = useAuth()
  const loading = useLoading()
  const [order, setOrder] = useState<lobbyTab[] | never>([])
  const [initialOrder, setInitialOrder] = useState<lobbyTab[] | never>([])
  const [addValue, setAddValue] = useState('')
  const log = {
    log_type: 'visited',
    log_object: 'game_orderings'
  }
  const [modal, setModal] = useState<modalTag>({
    action: false,
    objectType: false,
    title: "",
    tags:  [],
    allTags: []
  })



  useEffect(() => {
    sendSystemLog(log);
  }, [])

  async function onRefresh() {
    const res = await getLobbyTabs()
    setOrder(res.tabs)
    setInitialOrder(res.tabs)
  }

  useEffect(() => {
    (async () => {
      loading.addLoading()
      await onRefresh();
      loading.removeLoading()
    })()
  }, [])

  useEffect(() => {
    console.log("order: ")
    console.log(order)
  }, [order])

  useEffect(() => {
    console.log("initialOrder: ")
    console.log(initialOrder)
  }, [initialOrder])

  const dummy = ()=> {

  }

  const onDragEnd = (result: DropResult): void => {


    if (!result.destination|| !canEdit) {
      return;
    }

    const items: lobbyTab[] = reorder(
      order,
      result.source.index,
      result.destination.index
    );

    setOrder(items);
  };

  const replaceTab = (tab: lobbyTab): void => {

    console.log("Entering ReplaceTab")
    let tabs: lobbyTab[] = []
    order.forEach((tmpTab) => {
      if (tab.title === tmpTab.title){
        tabs.push(tab)
      } else {
        tabs.push(tmpTab)
      }
    })

    setOrder(tabs);
  };

  const onSubmit = async () => {
    loading.addLoading()
    let payload: typeof order = []
    if(order.length > 0) {
      payload = order.map((item, index) => ({...item, order: `${index}`}))
    }
    const res = await saveLobbyTabs(payload)
    setOrder(res.tabs)
    setInitialOrder(res.tabs)
    loading.removeLoading()
  }
  const closeTagsModal = async(tags: string[]) => {
    console.log("Entering closeTagsModal " + JSON.stringify(tags))
    console.log("Title: " + modal.title)
    console.log("Initial: " + JSON.stringify(initialOrder))
    let tab: lobbyTab | null = getTab(modal.title)
    if (tab != null)
      { // @ts-ignore
        if (JSON.stringify(tags)!==JSON.stringify(tab.tags)) {
          tab.tags = tags
          replaceTab(tab)
        }
      }
    setModal({...modal, action: false})
    console.log("Initial: " + JSON.stringify(initialOrder))
    console.log("Order:" + JSON.stringify(order))
  }

  const getTab = (title : string) => {
    let retVal : lobbyTab = {
      title: "",
      order: "-1",
      tags: []
    }
    order.forEach((tab) => {
      if (tab.title === title){
        retVal.title = tab.title
        retVal.order = tab.order
        retVal.tags = tab.tags

      }
    })
    return retVal.order === "-1"?null:retVal
  }
  const getAllUsedTags = () :string[] => {
    let retVal : string[] = []
    let tagList : string = ""
    order.forEach((game) => {
      if (game.tags){
        game.tags.forEach((tag) => {
          if (!tagList.includes("|" + tag + "|")){
            retVal.push(tag)
            tagList = tagList + "|" + tag + "|"
          }
        })
      }
    })
    return retVal
  }
  const saveNewTab = async (option: string) => {
    let next = 1
    if (order.length>= next)
      next = order.length + 1
    let tab :lobbyTab = {
      order: next.toString(),
      title: addValue,
      tags: []
    }
    let tabs: lobbyTab[] = []
    let found = false
    order.forEach((tmpTab) => {
      if (tab.title !== tmpTab.title){
        tabs.push(tmpTab)
      } else {
        found = true
      }
    })
    tabs.push(tab)
    if (!found)
      setOrder(tabs);
    setAddValue('')
  }

  const deleteTab = async (title: string) => {
    let tabs : lobbyTab[] = []

    let next = 1
    order.forEach((tab) => {
      if (tab.title !== title){
        tab.order = next.toString()
        next += 1
        tabs.push(tab)
      }
    })
    setOrder(tabs)
  }

  const headers = [
    { label: 'Order', key: 'order' },
    { label: 'Title', key: 'title' },
    { label: 'Tags', key: 'tags' },
  ];

  return (
    <div className="lobby-order">
    <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <ModalTagsSelector
          visible={modal.action}
          title={"Manage Tags for " + modal.title}
          tags={modal.tags}
          allTags={modal.allTags}
          onClose={closeTagsModal}
      />

      <FloatingButton
      text="Save"
      onClick={onSubmit}
      disabled={(JSON.stringify(initialOrder) === JSON.stringify(order))|| !canEdit}
    />
      <CSVLink style={{display: order?.length > 0 ? 'flex' : 'none'}}
               filename={"Lobby_tabs.csv"}
               className="floating-button-left"
               data={order}
               headers={headers}>
        <PlusOutlined style={{color: '#FFF', fontSize: window.innerWidth > 600 ? 20 : 16}} />
        <div className="floating-button__text">
          Export CSV
        </div>
      </CSVLink>

      <Space>
        <Input
            label="Create New Tab"
            value={addValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddValue(e.target.value)}
            placeholder="New Tab"
        />
        <Button
            onClick={() =>  saveNewTab(addValue)}
            type='primary'
            disabled={!addValue}
        >
          <PlusOutlined style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
      </Space>

      {order && order.length > 0 ? (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot): JSX.Element => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {order.map((item, index) => (
                  <Draggable key={item.title} draggableId={item.title} index={index}>
                    {(provided, snapshot): JSX.Element => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="lobby-order__drag"
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <div className="lobby-order__drag__text">
                          <h3>#{index + 1} {item.title}</h3> <p>{item.tags && item.tags.length > 0?"Tags: " + JSON.stringify(item.tags):""}</p>
                        </div>
                        <div>
                          <Button
                              onClick={() => setModal({...modal, action: true, title: item.title, tags: item.tags, allTags: getAllUsedTags()})}
                              type='primary'
                              style={{backgroundColor: '#2fa4e7'}}
                              disabled={!canEdit}
                          >
                              <TagsOutlined style={{ fontSize: '16px', color: '#FFF' }} />
                          </Button>
                          <Button
                              onClick={() => deleteTab(item.title)}
                              type='primary'
                              style={{backgroundColor: 'Red'}}
                              disabled={!canEdit}
                          >
                            <DeleteOutlined style={{ fontSize: '16px', color: '#FFF' }} />
                          </Button>
                        </div>

                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : null}
    </div>
  )
}

export default index;
